// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"1bf46185","537":"593368f0","879":"560f3814"}[chunkId] + ".chunk.js";
};